export const testIds = {
  addressCopy: { container: "address-copy" },
  assetAmountBox: {
    container: "asset-amount-box-container",
    input: "asset-amount-box-input",
    usdValue: "asset-amount-box-usd-value",
    balance: "asset-amount-box-balance",
    maxButton: "asset-amount-box-max-button",
  },
  assetSelectDialog: { content: "asset-select-dialog-content" },
  assetSelectFlow: {
    initial: { container: "initial-asset-select-container" },
    input: "asset-select-input",
  },
  exchangeFlow: {
    buy: {
      container: "buy-order-container",
      buyInputAmount: {
        container: "buy-input-amount-container",
        maxButton: "buy-input-amount-max-button",
      },
    },
    sell: {
      container: "sell-order-container",
      sellInputAmount: {
        sellAllButton: "sell-input-amount-sell-all-button",
      },
    },
    swap: {
      container: "swap-order-container",
      orderExecuted: {
        infoContainer: "order-executed-info-container",
      },
    },
    swapParameters: {
      container: "swap-parameters-container",
      limitOrderInput: {
        container: "limit-order-input-container",
        loadingIndicator: "limit-order-input-loading-indicator",
        input: "limit-order-input-input-field",
        assetA: "limit-order-input-asset-a",
        perAsset: "limit-order-input-per-asset",
      },
      liquidityPoolDropdown: {
        container: "liquidity-pool-dropdown-container",
        select: "liquidity-pool-dropdown-select",
        item: "liquidity-pool-dropdown-select-item",
      },
      orderTypeSelect: {
        container: "order-type-select-container",
        select: "order-type-select-select",
        item: "order-type-select-select-item",
      },
    },
    transactionOverview: {
      container: "transaction-overview-container",
    },
    notEnoughAssets: "not-enough-assets",
  },
  walletButton: {
    connectWalletButton: "connect-wallet-button",
    walletDetailsPopover: "wallet-details-popover",
  },
  newsBanner: "news-banner",
  balanceWithAssetName: { value: "balance-value", assetName: "balance-asset-name" },
  chartSkeleton: { wrap: "chart-skeleton-wrap", error: "chart-skeleton-error" },
  activeNewsDialog: { content: "active-news-dialog-content" },
  chooseHandleDialog: { content: "choose-handle-dialog-content" },
  createPoolDialog: { content: "create-pool-dialog-content" },
  exchangeSettingsDialog: { content: "exchange-settings-dialog-content" },
  harvestRewardsDialog: { content: "harvest-rewards-dialog-content" },
  lockLiquidityDialog: { content: "lock-liquidity-dialog-content" },
  poolSelectDialog: { content: "pool-select-dialog-content" },
  provideLiquidityDialog: { content: "provide-liquidity-dialog-content" },
  swapDialog: { content: "swap-dialog-content" },
  unlockLiquidityDialog: { content: "unlock-liquidity-dialog-content" },
  withdrawLiquidityDialog: { content: "withdraw-liquidity-dialog-content" },
  wrongNetworkDialog: { content: "wrong-network-dialog-content" },
  zapDialog: { content: "zap-dialog-content" },
  lightweightChart: { chart: "lightweight-chart-ref" },
  walletConnectDialog: { content: "wallet-connect-dialog-content" },
  yieldFarming: {
    positions: {
      ctas: {
        create: "positions-create-cta",
        unlockAll: "positions-unlock-all-cta",
        update: "positions-update-cta",
      },
      table: {
        noContent: "positions-table-nocontent",
      },
      dialogs: {
        edit: "positions-dialog",
        unlock: "positions-unlock-dialog",
      },
    },
    delegations: {
      ctas: {
        update: "delegations-update-cta",
      },
      table: {
        header: {
          column1: "delegation-program",
          column2: "delegation-amount",
          column3: "delegation-percentage",
        },
        noContent: "delegations-table-nocontent",
      },
      dialog: {
        container: "delegations-dialog",
        undelegatedPercentage: "delegations-dialog-undelegated-percentage",
      },
    },
    earnings: {
      program: (index: number) => `earnings-program-${index}`,
      balance: (index: number) => `earnings-balance-${index}`,
      noDataIndicator: "no-data-indicator",
      claimButton: "claim-button",
      dialog: {
        container: "earnings-dialog",
      },
    },
  },
};
